module.exports = __webpack_public_path__ + "static/media/IPFS.e89876356631a3939c2e24ee2ef1450a.png";